import React from 'react';
import { CreditCardIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
import { MOCKUP_URL } from '../../data/content';
export function FinalCTA() {
  return <section className="w-full bg-navy-900 px-4 py-14 text-white sm:py-20" aria-labelledby="final-title" data-id="element-148" data-mp="3rs388htw2ljk">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-149" data-mp="3ds0un7sm6ea4">
        <h2 id="final-title" className="font-display text-[26px] font-black uppercase leading-[1.12] sm:text-4xl lg:text-[44px]" data-id="element-150" data-mp="3hv6zqc3zpzf0">
          Your next post-laser assessment deserves <span className="text-gold-400" data-id="element-151" data-mp="33x8v3yfh1hcp">a clearer workflow</span>
        </h2>
        <div className="mt-5 space-y-3 text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-152" data-mp="38u91kag8gm4c">
          <p data-id="element-153" data-mp="124cd1rn59ej3">You already bring professional knowledge and clinical judgment to your work.</p>
          <p data-id="element-154" data-mp="17246wr7cnapx">Now give your assessment documentation a more organized structure.</p>
          <p data-id="element-155" data-mp="q7c5msukyaai">
            With the <strong className="text-accent-400" data-id="element-156" data-mp="q6sohecr7pxj">LASER COMPLICATION DECISION MAP™</strong>, you can organize
            relevant findings, document professional concerns, and structure communication and escalation decisions.
          </p>
        </div>

        <img src={MOCKUP_URL} alt="Complete blueprint package" className="-mx-2 mt-8 w-[calc(100%+1rem)] max-w-none rounded-2xl bg-white p-2 sm:mx-0 sm:w-full" data-id="element-157" data-mp="uytx8qapqyit" />

        <p className="mt-8 text-sm font-bold uppercase tracking-wide text-gold-400" data-id="element-158" data-mp="7bm2h2awv7v1">Get the complete blueprint today</p>
        <p className="mt-2 font-display text-lg font-black uppercase sm:text-2xl" data-id="element-159" data-mp="ga7hinh6c4r2">6 Practical Volumes + 5 Professional Bonuses</p>
        <p className="mt-3 font-display text-5xl font-black text-gold-400 sm:text-6xl" data-id="element-160" data-mp="babbkiox238v">
          ONLY $27 <span className="text-xl text-white/70" data-id="element-161" data-mp="1rol1hh8t401t">USD</span>
        </p>
        <p className="mt-2 text-sm text-white/70" data-id="element-162" data-mp="1mqruilzoj20h">Automatic currency conversion at checkout.</p>

        <div className="mt-8 flex w-full flex-col items-center gap-6" data-id="element-163" data-mp="kddio0zjyzp3">
          <ScarcityBar dark data-id="element-164" data-mp="kf7saj5dj5dv" />
          <CTAButton data-id="element-165" data-mp="pby958p0650c">Yes! I want my clinical decision blueprint</CTAButton>
          <CountdownTimer dark data-id="element-166" data-mp="pe17qh4816go" />
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-medium text-white/85" data-id="element-167" data-mp="tda3tsmqhgfe">
            <span className="flex items-center gap-1.5" data-id="element-168" data-mp="ybtlhguao61y">
              <ZapIcon className="h-4 w-4 text-gold-400" aria-hidden="true" data-id="element-169" data-mp="1mlys5hxvqwg" />
              Instant Digital Access
            </span>
            <span className="flex items-center gap-1.5" data-id="element-170" data-mp="5p8z6usoek59">
              <CreditCardIcon className="h-4 w-4 text-gold-400" aria-hidden="true" data-id="element-171" data-mp="anah3ced8df5" />
              One-Time Payment
            </span>
            <span className="flex items-center gap-1.5" data-id="element-172" data-mp="feaai7oa0dcw">
              <ShieldCheckIcon className="h-4 w-4 text-accent-400" aria-hidden="true" data-id="element-173" data-mp="ffv9qaljckh3" />
              7-Day Money-Back Guarantee
            </span>
          </div>
        </div>
      </div>
    </section>;
}